export const RealBricksLogo = (props) => {
  const { size = 52, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 52 52'>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M9.247 27.53a2.155 2.155 0 010-3.047l15.23-15.234a2.154 2.154 0 013.046 0l15.23 15.234a2.155 2.155 0 010 3.046l-15.23 15.234a2.154 2.154 0 01-3.046 0L9.247 27.53zm16.245-14.558a.718.718 0 011.016 0l5.076 5.079c.28.28.28.735 0 1.015L19.063 31.592a.718.718 0 01-1.016 0l-5.076-5.078a.718.718 0 010-1.016l12.522-12.526zm7.446 7.448a.718.718 0 011.016 0l5.077 5.078c.28.28.28.735 0 1.016l-5.077 5.078a.718.718 0 01-1.016 0l-5.077-5.078a.718.718 0 010-1.016l5.077-5.078z'
          clipRule='evenodd'
        ></path>
      </svg>
    </span>
  );
};
